import { isPlatformServer } from '@angular/common';
import { Component, Inject, PLATFORM_ID } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { switchMap, take, takeUntil, timer } from 'rxjs';
import { GameItem } from 'src/app/apollo/models/base-models';
import { MainMissionComponent } from 'src/app/components/missions/main-mission/main-mission.component';
import { missionsTrx } from 'src/app/router-translation.labels';
import { UserInfoService } from 'src/app/services/auth/check-session/user-info.service';
import { LoginStatusService } from 'src/app/services/auth/login/login-status.service';
import { MissionService } from 'src/app/services/missions/mission.service';
import { Mission } from 'src/app/services/missions/missions.models';
import { DetectDeviceService } from 'src/app/services/utils/detect-device.service';
import { LicenceService } from 'src/app/services/utils/licence.service';
import { DialogClosePreviousUrl } from 'src/app/services/utils/dialog-close-previouse-url.service';
import { BalanceStatusService } from 'src/app/services/wallet/balance-status.service';
import { BalanceService } from 'src/app/services/wallet/balance.service';
import { TranslationConfig } from 'src/app/utils/translate-config';

@Component({
  selector: 'app-launch-missions',
  templateUrl: './launch-missions.component.html',
  styleUrls: ['./launch-missions.component.scss']
})
export class LaunchMissionComponent extends MainMissionComponent {

  constructor(
    public route: ActivatedRoute,
    @Inject(PLATFORM_ID) public platformId,
    protected translationConfig: TranslationConfig,
    public loginStatusService: LoginStatusService,
    public balanceService: BalanceStatusService,
    public router: Router,
    public detectDesktopService: DetectDeviceService,
    public userInfoService: UserInfoService,
    dialog: MatDialog,
    public licenceService: LicenceService,
    public missionservice: MissionService,
    private prevUrlService: DialogClosePreviousUrl
  ) {
    super(
      null,
      translationConfig,
      loginStatusService,
      balanceService,
      router,
      null,
      detectDesktopService,
      userInfoService,
      dialog,
      missionservice,
      null,
      licenceService
    )
  }
  isInGame: boolean = false;
  mission: Mission;
  public missionsTrx = this.translationConfig.getTranslation(missionsTrx);
  isShowMore: boolean = false;
  INITIAL_RANK_LENGTH: number = 4;
  SHOWMORE_RANK_LENGTH: number = 200;
  rankSize = this.INITIAL_RANK_LENGTH;

  ngOnInit(): void {
    if (!isPlatformServer(this.platformId)) {
      this.route.data.pipe(take(1)).subscribe(data => this.isInGame = data?.isInGame)
      this.route.params
        .pipe(
          switchMap((params) => {
            const tournamentId = params['index'];
            return this.missionservice.getMission(tournamentId);
          }
          ),
          takeUntil(this.unsubscribe))

        .subscribe((mission: Mission) => {
          this.mission = mission;
          this.initialaze(mission);

          timer(100).pipe(take(1)).subscribe(() => {
            this.prevUrlService.getUrl().pipe(take(1)).subscribe(path => {
              if (path?.includes(missionsTrx) && path.length > 2) {
                window.scrollTo(0, this.prevUrlService.getScrollPosition())
              }
            })
          })
        })
    }
  };

  onGameSelect(game: GameItem) {
    this.launchGame(game.gameid, game.systemName);
  }


}
